// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1HUop","obliqueLineWrap":"membershipbadge_obliqueLineWrap__RFHkJ","obliqueLine":"membershipbadge_obliqueLine__3CHeC"};